import React, { memo } from "react"

const IconBook = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
  </svg>
)

const IconBalance = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="3" x2="12" y2="21"/>
    <path d="M5 8l7-5 7 5"/>
    <path d="M5 8c0 2.761 2.239 5 5 5s5-2.239 5-5"/>
    <path d="M9 8c0 2.761 2.239 5 5 5s5-2.239 5-5"/>
    <line x1="3" y1="21" x2="21" y2="21"/>
  </svg>
)

const IconGift = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 12 20 22 4 22 4 12"/>
    <rect x="2" y="7" width="20" height="5"/>
    <path d="M12 22V7"/>
    <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>
    <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
  </svg>
)

const IconHeart = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
)

const CARDS = [
  {
    cls: "div1",
    icon: <IconBook />,
    label: "Continuous Learning",
    text: "Grow through international projects, structured learning circles, and sponsored training and certifications that keep your skills ahead of the curve.",
  },
  {
    cls: "div2",
    icon: <IconBalance />,
    label: "Work-Life Balance",
    text: "Enjoy remote and flexible work arrangements, family-friendly policies, generous time off, and on-site activities designed to keep you energised and fulfilled.",
  },
  {
    cls: "div3",
    icon: <IconGift />,
    label: "Rewards & Perks",
    text: "Your contributions are recognised through long-stay awards, bi-annual performance reviews, annual increments, and a competitive perks package.",
  },
  {
    cls: "div4",
    icon: <IconHeart />,
    label: "Inclusive Culture",
    text: "We champion a merit-first environment where every voice is heard, every background is respected, and opportunities are open to all — equally.",
  },
]

const CareerFirst = () => (
  <div className="career position-relative">
    <div className="careerFirst">
      {CARDS.map(({ cls, icon, label, text }) => (
        <div key={cls} className={`cf-card ${cls}`}>
          <div className="cf-card__icon">{icon}</div>
          <div className="cf-card__label">{label}</div>
          <p className="cf-card__text">{text}</p>
        </div>
      ))}
    </div>
  </div>
)

export default memo(CareerFirst)
